import React, {useContext} from 'react';
import styled, {css} from 'styled-components';
import {useTranslations} from "use-intl";

import {useModal} from '@tager/web-components';

import ContentContainer from '@/components/ContentContainer';
import {ReactComponent as Icon} from '@/assets/svg/Calculator/calculator.svg';
import {colors} from '@/constants/theme';
import {getCurrentProject, normalizePrice} from '@/utils/common';
import {productContext} from '@/providers/Product';
import {useSettingItem} from "@/hooks";

import ProductCalculator from '../CardCalculator';

function Price() {
  const openModal = useModal();
  const {price, discountPrice} = useContext(productContext);
  const t = useTranslations();

  const currency = useSettingItem('CURRENCY');
  return (
    <Component>
      <ContentContainer>
        <PriceWrapper>
          {price ? (
            <PriceLabel isDiscount={!!discountPrice}>
              {normalizePrice(price)} {currency}
            </PriceLabel>
          ) : null}
          {discountPrice ? (
            <PriceLabel>{normalizePrice(discountPrice)} {currency}</PriceLabel>
          ) : null}
        </PriceWrapper>
        {getCurrentProject() !== 'dveri' &&
          <CalcButton
            onClick={() => {
              openModal(
                ProductCalculator,
                {productPrice: price},
                {
                  withAnimation: false,
                  scrollLockDisabled: true,
                }
              );
            }}
          >
            <StyledIcon/>
            {t('rassrochka.title')}
          </CalcButton>}
      </ContentContainer>
    </Component>
  );
}

export default Price;

const Component = styled.div`
  padding-bottom: 15px;
  margin-top: 20px;
  border-bottom: 1px solid ${colors.gray70};
`;

const PriceWrapper = styled.div`
  display: flex;
  align-items: center;

  & > span:not(:first-child) {
    margin-left: 15px;
  }
`;

const PriceLabel = styled.span<{ isDiscount?: boolean }>`
  ${({isDiscount}) =>
    isDiscount
      ? css`
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        text-decoration-line: line-through;
        font-size: 18px;
        color: ${colors.darkGrey};
      `
      : css`
        font-style: normal;
        font-weight: 600;
        font-size: 30px;
        line-height: 26px;
        color: ${colors.black};
      `}
`;
const DiscountLabel = styled.span`
  margin-left: 16px;
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 26px;
`;

const CalcButton = styled.button`
  margin-top: 2px;
  display: flex;
  align-items: center;
  max-width: 480px;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 24px;
  color: ${colors.primary};
`;

const StyledIcon = styled(Icon)`
  margin-right: 8px;
`;
